export const PICKUP_DELIVERY_OPTION_TYPES = ['PICKUP', 'COLLECT'];
